// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1EhBi","insightsList":"newBusinessInsightsMenu_insightsList__2LyLz","active":"newBusinessInsightsMenu_active__38lUb"};